import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMass = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_3004_29298",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 100,
		height: 100,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 99,
			height: 99,
			fill: "#C4C4C4",
			stroke: "#9EA9B9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_3004_29298)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M88.0596 69.9804L88.06 53.6926L42.9622 79.0738L42.9618 95.3616L88.0596 69.9804Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42.9621 79.0735L19.1443 66.1793L19.1437 82.5329L42.9615 95.427L42.9621 79.0735Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M88.2572 53.5205L64.5741 40.6993L19.2827 66.2527L42.9658 79.0738L88.2572 53.5205Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M88.0586 54.0614L88.059 37.7737L42.9613 63.1548L42.9608 79.4426L88.0586 54.0614Z",
				fill: "#F6DCC4",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42.9621 63.1551L19.1443 50.2609L19.1437 66.6144L42.9615 79.5086L42.9621 63.1551Z",
				fill: "#F6DCC4",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M88.2563 37.6015L64.5732 24.7804L19.2817 50.3337L42.9648 63.1548L88.2563 37.6015Z",
				fill: "#F6DCC4",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M37.75 10.0239C38.8092 10.024 39.8532 10.2783 40.7939 10.7651C41.7347 11.252 42.5454 11.9571 43.1572 12.8218C43.769 13.6865 44.1645 14.6857 44.3105 15.7349C44.4404 16.6681 44.3688 17.6168 44.1035 18.5181H39.9268C40.125 18.2878 40.2877 18.0274 40.4053 17.7437C40.6228 17.2184 40.6803 16.6401 40.5693 16.0825C40.4584 15.5249 40.1842 15.0128 39.7822 14.6108C39.3802 14.2089 38.8681 13.9346 38.3105 13.8237C37.753 13.7128 37.1746 13.7702 36.6494 13.9878C36.1243 14.2054 35.6752 14.5738 35.3594 15.0464C35.0436 15.519 34.8751 16.0747 34.875 16.6431C34.875 17.3341 35.1261 17.9981 35.5742 18.5181H31.3965C31.1311 17.6167 31.0596 16.6681 31.1895 15.7349C31.3355 14.6857 31.7309 13.6865 32.3428 12.8218C32.9546 11.9571 33.7652 11.252 34.7061 10.7651C35.6469 10.2784 36.6907 10.0239 37.75 10.0239Z",
				fill: "#FDF1E6",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.666 18.1108H48.9854C49.8002 18.1111 50.5581 18.71 50.791 19.6411L56.208 41.3188C56.761 43.5309 55.2241 45.6057 53.2588 45.606H22.3887C20.4844 45.606 18.9824 43.6585 19.3965 41.5259L19.4434 41.3188L24.8604 19.6411V19.6401C25.0927 18.7101 25.851 18.1108 26.666 18.1108Z",
				fill: "#FDF1E6",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41.3691 29.6611C41.5123 29.6611 41.646 29.6731 41.7715 29.6934C41.6995 29.6874 41.6259 29.6836 41.5518 29.6836C40.9848 29.6837 40.4784 29.8525 40.0762 30.2197L40.0723 30.2236C39.6719 30.5973 39.4795 31.0856 39.4795 31.6416C39.4796 32.2014 39.6706 32.6941 40.0684 33.0742L40.0762 33.0811C40.4784 33.4483 40.9848 33.6171 41.5518 33.6172C41.6186 33.6172 41.685 33.6142 41.75 33.6094C41.6299 33.6285 41.5034 33.6406 41.3691 33.6406C40.9562 33.6406 40.5942 33.555 40.2744 33.3916H40.2754C39.9998 33.2425 39.7763 33.0447 39.6006 32.7939L39.5283 32.6836C39.3558 32.3906 39.2637 32.0481 39.2637 31.6416C39.2637 31.2333 39.3565 30.894 39.5283 30.6084C39.7128 30.3061 39.9569 30.0757 40.2686 29.9121C40.5897 29.7469 40.9538 29.6611 41.3691 29.6611ZM33.2549 28.1172V32.3203L34.1143 31.4287L37.3057 28.1172H37.3457L35.3008 30.2949L35.0029 30.6123L35.2754 30.9512L37.6299 33.8721H37.4424L35.208 31.2227L34.8525 30.8008L34.4678 31.1963L33.3965 32.2959L33.2549 32.4414V33.8721H33V28.1172H33.2549ZM43.6543 29.7188H43.8027V33.5908C43.8027 34.4179 43.5918 34.9474 43.2578 35.2744C42.9218 35.6033 42.3751 35.8115 41.5234 35.8115C41.0719 35.8115 40.6493 35.7533 40.2539 35.6387L40.2471 35.6367L39.9707 35.5479C39.8689 35.5099 39.7756 35.4667 39.6885 35.4219L39.7188 35.3721C39.883 35.4568 40.0592 35.5286 40.2461 35.5889V35.5898C40.6425 35.7219 41.0468 35.7891 41.4561 35.7891C42.0843 35.789 42.6532 35.6477 43.0498 35.2607C43.4452 34.875 43.5967 34.3291 43.5967 33.7256V32.167L43.5332 32.2354C43.5876 32.0484 43.6152 31.8499 43.6152 31.6416C43.6152 31.4878 43.5986 31.3394 43.5684 31.1973L43.6543 31.3018V29.7188Z",
				fill: "#A35705",
				stroke: "#A35705"
			})
		]
	})]
});
export default SvgMass;
